module.exports = __webpack_public_path__ + "img/index06.e9647050.jpg";